import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

const QuickLinkCount = new ReduxAsyncAction('QUICK_LINK_COUNT');
QuickLinkCount.registerRequest(function () {
  return dash_api.get(`/v1/marketing/link-count`).then(({ data }) => {
    return data.links;
  });
});
export const getQuickLinkCount = QuickLinkCount.request;
export const QUICK_LINK_COUNT = QuickLinkCount.constants;

const GetAllQuickLinks = new ReduxAsyncAction('GET_ALL_QUICK_LINKS');
GetAllQuickLinks.registerRequest(function () {
  return dash_api.get('v1/link/marketing').then(({ data }) => data);
});
export const getAllQuickLinks = GetAllQuickLinks.request;
export const GET_ALL_QUICK_LINKS = GetAllQuickLinks.constants;
